import Vue from 'vue'
import './plugins/vuetify'
import './plugins/base'
import * as firebase from 'firebase/app'
import App from './App.vue'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.min.css'
import i18n from './i18n'
Vue.config.productionTip = false

new Vue({
  store,
  i18n,
  created () {
    const firebaseConfig = {
      apiKey: 'AIzaSyCDuR98Zda2Tz3jFw2SwmfcbrIqn5kRNOM',
      authDomain: 'freelance-ab84c.firebaseapp.com',
      databaseURL: 'https://freelance-ab84c.firebaseio.com',
      projectId: 'freelance-ab84c',
      storageBucket: 'freelance-ab84c.appspot.com',
      messagingSenderId: '641204800316',
      appId: '1:641204800316:web:e3714dbd33cbfe64'
    }
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig)
    this.$store.dispatch('setLanguage', getUserLang()).then(this.$i18n.locale = this.$store.getters.getLanguage)
  },
  render: h => h(App)
}).$mount('#app')

function getUserLang () {
  if (navigator.languages !== undefined) { return navigator.languages[0].slice(0, 2) } else { return navigator.language }
}
